import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getNftDetails, getNfts } from '~services'
import { NftDetailsInput, NftDetailsResponse, NftsResponse } from '~types/nfts'

const { NFTS_LIST } = QUERY_KEYS

const nftQueryKey = [NFTS_LIST] as [string]

export const useGetNfts = () => {
  const {
    data: nftsData,
    status: nftsStatus,
    refetch: refetchNfts,
    isFetchedAfterMount: isFetchedNFTsAfterMount,
  } = useQuery<NftsResponse>(nftQueryKey, getNfts)

  return { refetchNfts, nfts: nftsData?.nfts, status: nftsStatus, isFetchedNFTsAfterMount }
}

const { NFT_DETAILS } = QUERY_KEYS

export const useGetNftDetails = (
  variables: NftDetailsInput,
  options?: UseQueryOptions<NftDetailsResponse, unknown, NftDetailsResponse>
) => {
  const nftDetailsQueryKey = [NFT_DETAILS, variables]
  const {
    data,
    refetch: refetchNftDetails,
    isFetching: isFetchingNftDetails,
    isLoading: isLoadingNftDetails,
  } = useQuery<NftDetailsResponse>(nftDetailsQueryKey, () => getNftDetails(variables))

  return {
    nftDetails: data?.nftDetails,
    isFetchingNftDetails,
    isLoadingNftDetails,
    refetchNftDetails,
  }
}
